import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// FIXME: Need to update types for SocialButtons component [propsByNetwork, onClickApple, onClickTinkoff]
import { Button, Divider, SocialButtons, SocialName, Text } from '@s7/ui-kit';
import TinkoffId from '@s7/ui-kit/icons/TinkoffId';
import classNames from 'classnames/bind';
import React, { useEffect, useMemo } from 'react';
import AuthorizationGroup from '../AuthorizationGroup';
import { getModalTitle } from '../Login/utils';
import ModalAuthorization from '../ModalAuthorization';
import { SecondaryScreen } from '../SecondaryScreen';
import { useAnalyticsContext } from '../utils/analytics';
import styles from './Login.css';
var cx = classNames.bind(styles);

var Login = function Login(_ref) {
  var _getModalTitle;

  var isDesktop = _ref.isDesktop,
      dictionary = _ref.dictionary,
      isB2B = _ref.isB2B,
      fields = _ref.fields,
      heading = _ref.heading,
      footer = _ref.footer,
      headingColor = _ref.headingColor,
      info = _ref.info,
      _ref$isModal = _ref.isModal,
      isModal = _ref$isModal === void 0 ? false : _ref$isModal,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      isSocial = _ref.isSocial,
      _ref$loginDisabled = _ref.loginDisabled,
      loginDisabled = _ref$loginDisabled === void 0 ? false : _ref$loginDisabled,
      loginText = _ref.loginText,
      notification = _ref.notification,
      notificationTitle = _ref.notificationTitle,
      onClickApple = _ref.onClickApple,
      onClickFB = _ref.onClickFB,
      onClickGoogle = _ref.onClickGoogle,
      onClickOneTap = _ref.onClickOneTap,
      onClickVK = _ref.onClickVK,
      onClickYandex = _ref.onClickYandex,
      onClickTinkoff = _ref.onClickTinkoff,
      onClose = _ref.onClose,
      onLogin = _ref.onLogin,
      onRecover = _ref.onRecover,
      onRegister = _ref.onRegister,
      registrationHref = _ref.registrationHref,
      recoveryHref = _ref.recoveryHref,
      openRegistrationInNewTab = _ref.openRegistrationInNewTab,
      openRecoveryInNewTab = _ref.openRecoveryInNewTab,
      recoveryText = _ref.recoveryText,
      registrationText = _ref.registrationText,
      socialButtons = _ref.socialButtons,
      socialButtonsTitle = _ref.socialButtonsTitle,
      socialButtonsVisible = _ref.socialButtonsVisible,
      socialButtonsDisable = _ref.socialButtonsDisable,
      socialOneTapDisable = _ref.socialOneTapDisable,
      title = _ref.title,
      titleSize = _ref.titleSize,
      theme = _ref.theme,
      _ref$wrapFields = _ref.wrapFields,
      wrapFields = _ref$wrapFields === void 0 ? false : _ref$wrapFields,
      _ref$socialEmailAlrea = _ref.socialEmailAlreadyUsed,
      socialEmailAlreadyUsed = _ref$socialEmailAlrea === void 0 ? false : _ref$socialEmailAlrea,
      _ref$socialPhoneAlrea = _ref.socialPhoneAlreadyUsed,
      socialPhoneAlreadyUsed = _ref$socialPhoneAlrea === void 0 ? false : _ref$socialPhoneAlrea,
      socialType = _ref.socialType,
      socialName = _ref.socialName,
      socialEmail = _ref.socialEmail,
      socialPhone = _ref.socialPhone,
      _ref$socialEmailFound = _ref.socialEmailFoundText,
      socialEmailFoundText = _ref$socialEmailFound === void 0 ? 'Возможно, вы уже когда-то регистрировались в S7 Priority с этим email — ' : _ref$socialEmailFound,
      _ref$socialPhoneFound = _ref.socialPhoneFoundText,
      socialPhoneFoundText = _ref$socialPhoneFound === void 0 ? 'Возможно, вы уже когда-то регистрировались в S7 Priority с этим номером телефона — ' : _ref$socialPhoneFound,
      _ref$socialLoginText = _ref.socialLoginText,
      socialLoginText = _ref$socialLoginText === void 0 ? 'Если вы узнали в нем свой, войдите в личный кабинет или восстановите пароль.' : _ref$socialLoginText,
      _ref$socialLoginButto = _ref.socialLoginButtonText,
      socialLoginButtonText = _ref$socialLoginButto === void 0 ? 'Авторизоваться' : _ref$socialLoginButto,
      _ref$socialIgnoreButt = _ref.socialIgnoreButtonText,
      socialIgnoreButtonText = _ref$socialIgnoreButt === void 0 ? 'Пропустить' : _ref$socialIgnoreButt,
      socialOnIgnore = _ref.socialOnIgnore,
      popup = _ref.popup,
      providerSwitcher = _ref.providerSwitcher,
      getTestId = _ref.getTestId,
      sendGA = _ref.sendGA,
      onBackFromTwoFactor = _ref.onBackFromTwoFactor,
      twoFactorDetails = _ref.twoFactorDetails,
      loginBlockState = _ref.loginBlockState,
      token = _ref.token,
      handleLoginFailure = _ref.handleLoginFailure,
      handleLoginSuccess = _ref.handleLoginSuccess,
      setTwoFactorDetails = _ref.setTwoFactorDetails,
      setLoginBlockState = _ref.setLoginBlockState;

  var _useAnalyticsContext = useAnalyticsContext(),
      sendEvent = _useAnalyticsContext.sendEvent;

  var banner = React.useMemo(function () {
    if (notification || notificationTitle) {
      return _objectSpread({
        children: notification,
        title: notificationTitle,
        view: 'error'
      }, getTestId('alert'));
    }

    return null;
  }, [notification, notificationTitle]);
  var socialDataTestIds = useMemo(function () {
    return {
      networks: {
        google: getTestId('socialGoogle'),
        vk: getTestId('socialVK'),
        yandex: getTestId('socialYandex')
      },
      title: getTestId('socialTitle')
    };
  }, [getTestId]);

  var recoveryButton = _objectSpread({
    as: 'a',
    children: recoveryText,
    color: 'N300',
    onClick: function onClick() {
      onRecover();
      sendGA({
        eventActionPath: ['onClickForget']
      });
    },
    type: 'link'
  }, getTestId('passwordRecovery'));

  var recoveryLink = _objectSpread(_objectSpread({}, typeof recoveryHref === 'function' ? {
    onClick: function onClick() {
      sendGA({
        eventActionPath: ['onClickForget']
      });
      recoveryHref();
    }
  } : {
    href: recoveryHref,
    onClick: function onClick() {
      return sendGA({
        eventActionPath: ['onClickForget']
      });
    }
  }), {}, {
    as: 'a',
    children: recoveryText,
    color: 'N300',
    target: openRecoveryInNewTab ? '_blank' : null,
    type: 'link'
  }, getTestId('passwordRecovery'));

  var commonActions = [openRecoveryInNewTab || recoveryHref ? recoveryLink : recoveryButton].concat(_toConsumableArray(footer ? [footer] : []), [_objectSpread({
    block: true,
    children: loginText,
    disabled: loginDisabled,
    size: 'large',
    theme: theme,
    type: 'submit'
  }, getTestId('submit'))]);
  var actions = React.useMemo(function () {
    var result = commonActions;

    if (!isB2B) {
      result.push(_objectSpread({
        as: 'a',
        block: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        children: registrationText,
        href: registrationHref,
        onClick: function onClick(e) {
          if (onRegister) {
            onRegister(e);
          }

          sendGA({
            eventActionPath: ['onClickRegistration']
          });
        },
        rel: 'noopener noreferrer',
        size: 'large',
        target: openRegistrationInNewTab ? '_blank' : '_self',
        theme: 'secondary'
      }, getTestId('registration')));
    }

    return result;
  }, [loginText, onLogin, onRecover, onRegister, recoveryText, registrationText, isB2B]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isFieldsOpen = _React$useState2[0],
      setIsFieldsOpen = _React$useState2[1];

  var socialDataAlreadyUsedProps = {
    actions: [].concat(_toConsumableArray(isFieldsOpen ? commonActions : [{
      block: true,
      children: socialLoginButtonText,
      onClick: function onClick() {
        sendEvent({
          event: 'click_submit',
          flow: 'login',
          step: 'profile_already_exists',
          type: socialType
        });
        setIsFieldsOpen(true);
      },
      size: 'large',
      theme: 'b2c',
      type: 'button'
    }]), [{
      block: true,
      children: socialIgnoreButtonText,
      onClick: socialOnIgnore,
      size: 'large',
      theme: 'secondary',
      type: 'button'
    }]),
    bottom: null,
    fields: isFieldsOpen ? fields : null,
    heading: /*#__PURE__*/React.createElement(React.Fragment, null, socialPhoneAlreadyUsed ? socialPhoneFoundText : socialEmailFoundText, ' ', /*#__PURE__*/React.createElement("b", null, socialPhoneAlreadyUsed ? socialPhone : socialEmail), ".", socialName && socialType && /*#__PURE__*/React.createElement("div", {
      className: cx('social-name')
    }, /*#__PURE__*/React.createElement(SocialName, {
      name: socialName,
      type: socialType
    })), socialLoginText)
  };
  useEffect(function () {
    if (!socialButtonsDisable && !isB2B && !socialOneTapDisable) {
      if (onClickOneTap) {
        onClickOneTap();
      }
    }
  }, [socialButtonsDisable, isB2B, socialOneTapDisable]);
  useEffect(function () {
    if (socialEmailAlreadyUsed || socialPhoneAlreadyUsed) {
      sendEvent({
        event: 'view_screen',
        flow: 'login',
        step: 'profile_already_exists'
      });
    }
  }, [socialEmailAlreadyUsed, socialPhoneAlreadyUsed]);

  if (isSocial) {
    return /*#__PURE__*/React.createElement(SocialButtons, {
      onClickApple: onClickApple,
      onClickFB: onClickFB,
      onClickGoogle: onClickGoogle,
      onClickTinkoff: onClickTinkoff,
      onClickVK: onClickVK,
      onClickYandex: onClickYandex,
      title: socialButtonsTitle,
      visible: socialButtonsVisible
    });
  }

  var modalTitle = (_getModalTitle = getModalTitle(dictionary, twoFactorDetails, loginBlockState === null || loginBlockState === void 0 ? void 0 : loginBlockState.blockType, isDesktop)) !== null && _getModalTitle !== void 0 ? _getModalTitle : title;
  var secondaryScreenProps = twoFactorDetails || loginBlockState ? {
    backTitle: dictionary.t('com.login.title'),
    onBack: onBackFromTwoFactor
  } : {};

  var renderBottom = function renderBottom(socialButtonsDisable, isB2B, socialButtons, onClickTinkoff, onClickApple, onClickFB, onClickGoogle, onClickVK, onClickYandex, socialDataTestIds, socialButtonsVisible) {
    if (socialButtonsDisable || isB2B) {
      return null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: cx('social-title', 'social-block')
    }, /*#__PURE__*/React.createElement(Divider, {
      as: "div",
      classes: {
        root: cx('social-divider')
      },
      color: "N50"
    }), /*#__PURE__*/React.createElement(Text, {
      classes: {
        root: cx('social-or')
      },
      color: "N50",
      weight: "semibold"
    }, dictionary.t('com.login.social.or')), /*#__PURE__*/React.createElement(Divider, {
      as: "div",
      classes: {
        root: cx('social-divider')
      },
      color: "N50"
    })), onClickTinkoff && /*#__PURE__*/React.createElement(Button, {
      block: true,
      classes: {
        root: cx('tinkoff', 'social-block')
      },
      onClick: onClickTinkoff,
      size: "large"
    }, "\u0422-\u0411\u0430\u043D\u043A", /*#__PURE__*/React.createElement("div", {
      className: cx('tinkoff-icon-container')
    }, /*#__PURE__*/React.createElement(TinkoffId, {
      classes: {
        root: cx('tinkoff-icon')
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: cx('google-button') + ' g_id_signin',
      id: 'googleSignInDiv'
    }), /*#__PURE__*/React.createElement(SocialButtons, {
      classes: {
        buttons: cx('social-buttons')
      },
      onClickApple: onClickApple,
      onClickFB: onClickFB,
      onClickGoogle: onClickGoogle,
      onClickVK: onClickVK,
      onClickYandex: onClickYandex,
      propsByNetwork: socialDataTestIds.networks,
      visible: socialButtonsVisible
    }));
  };

  var socialData = socialEmailAlreadyUsed || socialPhoneAlreadyUsed ? socialDataAlreadyUsedProps : {
    actions: actions,
    fields: fields,
    heading: heading,
    bottom: renderBottom(socialButtonsDisable, isB2B, socialButtons, onClickTinkoff, onClickApple, onClickFB, onClickGoogle, onClickVK, onClickYandex, socialDataTestIds, socialButtonsVisible)
  };
  var content = twoFactorDetails || loginBlockState ? /*#__PURE__*/React.createElement(SecondaryScreen, {
    dictionary: dictionary,
    handleLoginFailure: handleLoginFailure,
    handleLoginSuccess: handleLoginSuccess,
    isDesktop: isDesktop,
    loginBlockState: loginBlockState,
    notification: banner,
    setLoginBlockState: setLoginBlockState,
    setTwoFactorDetails: setTwoFactorDetails,
    token: token,
    twoFactorDetails: twoFactorDetails
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthorizationGroup, _extends({
    form: {
      onSubmit: onLogin
    },
    headingColor: headingColor,
    info: info,
    notification: banner,
    providerSwitcher: providerSwitcher,
    wrapFields: wrapFields
  }, socialData, {
    getTestId: getTestId
  })), popup);
  return /*#__PURE__*/React.createElement(ModalAuthorization, _extends({
    hasPopup: Boolean(popup),
    isDesktop: isDesktop,
    isModal: isModal,
    isOpen: isOpen,
    onClose: onClose,
    title: modalTitle,
    titleSize: titleSize,
    getTestId: getTestId
  }, secondaryScreenProps), content);
};

export default Login;